import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useNavigate, useParams } from 'react-router-dom';
import Icon from 'carbon-react/lib/components/icon';
import Typography from 'carbon-react/lib/components/typography';
import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';
import { getWorkspaceDetailSettingsUrl } from '@futrli/shared-services';

import coreStyles from '../../core/common.scss';

export const OrgAccessForbiddenMessage = () => {
  const { workspaceId: tempWorkspaceId } = useParams();

  const workspaceId = tempWorkspaceId || '';

  const navigate = useNavigate();

  const handleOrgSettingsButtonClick = useCallback(() => {
    navigate(getWorkspaceDetailSettingsUrl(workspaceId));
  }, [workspaceId, navigate]);

  return (
    <div className={classNames(coreStyles.allCaughtUp, coreStyles.predict)}>
      <Icon type="warning" fontSize="extra-large" />
      <Typography className={coreStyles.title} variant="h1" mt="8px" fontWeight="500">
        <FormattedMessage
          id="predict.org_access_unavailable"
          defaultMessage="This organisation is not available for access at the moment."
        />
      </Typography>
      <Button buttonType="primary" mt="24px" onClick={handleOrgSettingsButtonClick}>
        <FormattedMessage id="common.organisation_settings" defaultMessage="Organisation settings" />
      </Button>
    </div>
  );
};
